import { useGetDataPDF } from "@/api/generate-hpdb";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function MapImage() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: dataPDF } = useGetDataPDF({ rfsId: id });

  const imageUrl = dataPDF?.documentMaps;

  return (
    <div className="flex h-[900px] w-full items-center justify-center bg-gray-50 p-4 print:w-[940px]">
      {imageUrl ? (
        <div className="relative flex h-full w-full items-center justify-center overflow-hidden">
          <img
            src={imageUrl}
            alt="map"
            className="min-h-full min-w-full object-contain shadow-lg"
            style={{
              maxHeight: "400px",
              maxWidth: "100%",
            }}
            onError={() => console.error("Failed to fetch media URI")}
          />
        </div>
      ) : (
        <div>Media stream not available</div>
      )}
    </div>
  );
}
